import axios, { AxiosResponse } from "axios";

import { authHeader } from "src/api/authHeader";
import { GenericObject } from "src/api/flowTypes";
import { pathJoin } from "src/api/paths";
import { FileResponse } from "src/clients/files";

const getFilesApiUrl = (flowBaseUrl: string, url: string): string => {
  return pathJoin("https://", flowBaseUrl, `/public/files/api/v1`, url);
};

export const filesApiGet = <ResponseT>(
  baseUrl: string,
  url: string,
  params?: GenericObject,
): Promise<AxiosResponse<ResponseT>> => {
  return axios.get<ResponseT, AxiosResponse<ResponseT>>(
    getFilesApiUrl(baseUrl, url),
    {
      ...authHeader(false),
      params: params,
    },
  );
};

export const getFileEnvAgnostic = (
  baseUrl: string,
  fileId: string,
): Promise<AxiosResponse<FileResponse>> => {
  return filesApiGet<FileResponse>(
    baseUrl,
    `/files/${encodeURIComponent(fileId)}`,
  );
};
